{
  "assetContainerEvent": {
    "types": {
      "arrived": "Đã đến",
      "arrivedWaiting": "Đã đến/Đang chờ",
      "loading": "Đang xếp hàng",
      "loadingComplete": "Đã xếp hàng xong",
      "unloading": "Đang dỡ hàng",
      "unloadingComplete": "Đã dỡ hàng xong",
      "readyForPickup": "Sẵn sàng để lấy",
      "departed": "Đã rời đi",
      "inoperable": "Không hoạt động được",
      "missing": "Thất lạc",
      "inTransit": "Đang di chuyển"
    }
  },
  "assetVisitYardEvent": {
    "Arrived": "Đã đến",
    "Docked": "Đã vào cửa kho",
    "Parked": "Đã đỗ",
    "Unassigned": "Chưa gán",
    "Dropped": "Đã thả",
    "Hooked": "Đã móc",
    "Appointment Linked": "Đã liên kết cuộc hẹn",
    "Appointment Unlinked": "Đã hủy liên kết cuộc hẹn",
    "Status Updated": "Cập nhật trạng thái"
  },
  "assetContainerTypes": {
    "trailer": "Rơ-moóc",
    "container": "Container",
    "oversized": "Quá khổ",
    "chassis": "Khung gầm (chassis)",
    "reefer": "Container lạnh",
    "other": "Khác"
  },
  "assetVisitTypes": {
    "live": "Bốc dỡ trực tiếp (Live)",
    "drop": "Thả rơ-moóc (Drop)",
    "pickup": "Móc rơ-moóc (Hook)",
    "dropHook": "Thả & Móc (Drop & Hook)"
  },
  "assetVisitDirections": {
    "inbound": "Nhập hàng",
    "outbound": "Xuất hàng",
    "inboundAndOutbound": "Nhập & Xuất hàng"
  },
  "loadTypeDirections": {
    "inbound": "Nhập hàng",
    "outbound": "Xuất hàng",
    "inOut": "Nhập & Xuất hàng"
  },
  "altAssetVisitTypes": {
    "unknown": "Không xác định"
  },
  "assetContainerStates": {
    "full": "Đầy",
    "empty": "Trống",
    "partiallyLoaded": "Có hàng một phần"
  },
  "spotStatuses": {
    "open": "mở",
    "closed": "đã đóng",
    "assigned": "đã gán",
    "inTransit": "đang di chuyển",
    "reservedManual": "đã đặt trước",
    "reservedAutomated": "đã đặt trước",
    "unknown": "không xác định"
  },
  "spotTypes": {
    "parking": "đỗ xe",
    "docking": "cửa kho"
  },
  "labels": {
    "licensePlate": "Biển số xe",
    "dotNumber": "Số DOT"
  },
  "messages": {
    "unknownCompany": "Công ty không xác định",
    "unhooked": "Đã tháo móc",
    "noInformationAvailable": "Không có thông tin",
    "noVisitFound": "Không tìm thấy lượt ghé",
    "notInformed": "Chưa cung cấp",
    "waitingAssignment": "Đang chờ gán",
    "failedToLoadSpotDetails": "Không thể tải chi tiết vị trí",
    "retry": "Thử lại",
    "blockedUntilSpotIsOpen": "Bị chặn cho đến khi {spot} mở",
    "blockReasons": {
      "reservedByOther": "Vị trí đích đã được **đặt trước** cho **Nhiệm vụ di chuyển #{taskNumber}**.",
      "reservedByOtherGeneric": "Vị trí đích đã được **đặt trước**.",
      "destinationClosed": "Vị trí đích đã **đóng**.",
      "destinationOccupied": "Vị trí đích đang bị **chiếm** bởi tài sản khác.",
      "anotherAssetInTransitForDestination": "**{assetCode}** đang được di chuyển đến vị trí này.",
      "assetInTransitElsewhere": "Tài sản đang được di chuyển bởi một nhiệm vụ di chuyển khác."
    }
  }
}
